import React, { useEffect } from "react";
import { MessageCircle } from "lucide-react";

export default function WhatsAppFloat() {
  // Fixed primary WhatsApp - config is fetched only if needed elsewhere
  const wa = "919848490057";
  const href = `https://wa.me/${wa}?text=${encodeURIComponent("Hello Aaha Kanakam Agri Traders, I would like to enquire about your agricultural commodities.")}`;
  return (
    <a
      data-testid="whatsapp-chat-button"
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-[0_16px_36px_-12px_rgba(37,211,102,0.6)] hover:scale-105 transition-transform"
    >
      <MessageCircle size={26} />
    </a>
  );
}
